export class FaturamentoBruto {

  valorTotalEmpresa: number;
  valorTotalSoftware: number;
  valorTotalServicosTI: number;
  valorExportacaoTotalEmpresa: number;
  valorExportacaoTotalProdutosIncentivados: number;
  valorExportacaoSoftware: number;
  valorExportacaoServicos: number;
  valorImportacaoTotalEmpresa: number;
  valorImpotacaoTotalInsumos: number;
  valorImportacaoProdutosRevenda: number;
  valorImportacaoSoftware: number;
  valorImportacaoServicos: number;
  totalProdutosIncentivados: number;
  totalProdutosIncentivadosAreasInfluencia: number;

  constructor(init?: Partial<FaturamentoBruto>) {
    Object.assign(this, init);
  }
}
